"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AS_OF_DATE_CATEGORY_KEY = 'base';
exports.AS_OF_DATE_COMPONENT_KEY = 'asOfDate';